const gold = "#A88B5C";

function Corner({ color, rot, style }) {
  return (
    <svg viewBox="0 0 100 100" className="absolute w-[24mm] h-[24mm]" style={{ ...style, transform: `rotate(${rot}deg)` }} fill="none" stroke={color} strokeWidth="1.6" strokeLinecap="round">
      <path d="M6 94 V20 Q6 6 20 6 H94" />
      <path d="M14 70 Q14 30 30 22 Q44 16 46 30 Q47 40 37 40 Q30 40 31 33" />
      <path d="M70 14 Q30 14 22 30 Q16 44 30 46 Q40 47 40 37 Q40 30 33 31" />
      <path d="M22 22 Q34 30 30 42 M22 22 Q30 34 42 30" />
      <circle cx="22" cy="22" r="3" fill={color} />
    </svg>
  );
}

function Leaf({ rot, style }) {
  return (
    <svg viewBox="0 0 120 120" className="absolute w-[34mm] h-[34mm] opacity-80" style={{ ...style, transform: `rotate(${rot}deg)` }}>
      <path d="M4 116 Q40 70 112 8" stroke="#6E8B6A" strokeWidth="1.6" fill="none" />
      {[[22, 92, -40], [38, 74, 20], [52, 60, -50], [68, 46, 15], [84, 32, -55], [98, 20, 10]].map(([x, y, r], i) => (
        <ellipse key={i} cx={x} cy={y} rx="13" ry="5.5" transform={`rotate(${r} ${x} ${y})`} fill={i % 2 ? "#A7C4A0" : "#C9DCC2"} opacity="0.85" />
      ))}
      <circle cx="16" cy="104" r="6" fill="#E8C4C0" opacity="0.8" /><circle cx="104" cy="14" r="4.5" fill="#F2D9B8" opacity="0.9" />
    </svg>
  );
}

function Wave({ top }) {
  return (
    <svg viewBox="0 0 400 40" preserveAspectRatio="none" className={`absolute left-0 w-full h-[14mm] ${top ? "top-0 rotate-180" : "bottom-0"}`}>
      <path d="M0 22 Q50 6 100 22 T200 22 T300 22 T400 22 V40 H0Z" fill="#CFE6EC" />
      <path d="M0 30 Q50 16 100 30 T200 30 T300 30 T400 30 V40 H0Z" fill="#0B6E8F" opacity="0.35" />
    </svg>
  );
}

export const STYLES = {
  classico: { label: "Classico oro", bg: "#FFFFFF", title: gold, text: "#2B2B2B", head: "'Cormorant Garamond', serif", body: "'Cormorant Garamond', serif", caps: true, script: false },
  mare: { label: "Mare elegante", bg: "#FBF7EF", title: "#0B6E8F", text: "#1F3A44", head: "'Cormorant Garamond', serif", body: "'Cormorant Garamond', serif", caps: false, script: false },
  minimal: { label: "Moderno minimal", bg: "#FFFFFF", title: "#111111", text: "#333333", head: "'Plus Jakarta Sans', sans-serif", body: "'Plus Jakarta Sans', sans-serif", caps: true, script: false, track: true },
  botanico: { label: "Botanico acquerello", bg: "#FFFDF8", title: "#5E7A5A", text: "#3A3A33", head: "'Pinyon Script', cursive", body: "'Cormorant Garamond', serif", caps: false, script: true },
};

const MARKS = { ledo: ["Tenuta", "LEDO"], afrodite: ["Boutique Hotel", "AFRODITE"], catering: ["Catering", "PRIMERANO"], primerano: ["Banqueting", "PRIMERANO"] };

export function Wordmark({ logo, color, ink = "#2E2622", w = 120 }) {
  const [top, big] = MARKS[logo] || MARKS.primerano;
  return (
    <svg viewBox="0 0 400 170" style={{ width: `${w}mm`, height: `${w * 0.425}mm`, display: "block", flexShrink: 0 }} data-testid="wordmark">
      <text x="200" y="42" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontStyle="italic" fontSize="40" fill={color} style={{ fontVariant: "small-caps" }}>{top}</text>
      <text x="200" y="118" textAnchor="middle" fontFamily="'Cormorant Garamond', serif" fontWeight="600" fontSize={big.length > 8 ? 58 : big.length > 6 ? 64 : 96} letterSpacing="4" fill={ink}>{big}</text>
      <g fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round">
        <path d="M30 128 Q120 150 186 136 M214 136 Q280 150 370 128" />
        <path d="M30 128 Q14 120 22 104 Q34 94 42 106 Q46 116 36 116" />
        <path d="M370 128 Q386 120 378 104 Q366 94 358 106 Q354 116 364 116" />
      </g>
      <path d="M186 128 L214 128 L208 160 L192 160 Z" fill={color} />
      <text x="200" y="150" textAnchor="middle" fontFamily="'Pinyon Script', cursive" fontSize="18" fill="#fff">{big[0]}</text>
    </svg>
  );
}

export function Frame({ stile }) {
  if (stile === "classico") {
    return (
      <>
        <div className="absolute inset-[9mm] border-[0.5mm]" style={{ borderColor: gold }} />
        <div className="absolute inset-[11mm] border-[0.25mm]" style={{ borderColor: gold }} />
        <Corner color={gold} rot={0} style={{ left: "5mm", top: "5mm" }} />
        <Corner color={gold} rot={90} style={{ right: "5mm", top: "5mm" }} />
        <Corner color={gold} rot={270} style={{ left: "5mm", bottom: "5mm" }} />
        <Corner color={gold} rot={180} style={{ right: "5mm", bottom: "5mm" }} />
      </>
    );
  }
  if (stile === "mare") {
    return (<><Wave top /><Wave /><div className="absolute inset-x-[12mm] inset-y-[16mm] border-[0.3mm] border-[#0B6E8F]/40 rounded-[3mm]" /></>);
  }
  if (stile === "botanico") {
    return (<><Leaf rot={0} style={{ left: "2mm", bottom: "2mm" }} /><Leaf rot={180} style={{ right: "2mm", top: "2mm" }} /><Leaf rot={90} style={{ left: "2mm", top: "2mm" }} /></>);
  }
  return <div className="absolute inset-[12mm] border-[0.2mm] border-[#111]/20" />;
}

export function Divider({ stile, size }) {
  const c = STYLES[stile].title;
  if (stile === "minimal") return <div className="mx-auto" style={{ width: `${size * 6}mm`, height: "0.25mm", background: c, margin: `${size * 0.3}mm auto ${size * 0.55}mm` }} />;
  const mid = stile === "mare" ? <path d="M50 2 Q46 6 50 10 Q54 6 50 2Z M44 6 H40 M56 6 H60" fill={c} /> : stile === "botanico" ? <ellipse cx="50" cy="6" rx="5" ry="2.2" fill="#A7C4A0" /> : <path d="M44 6 Q47 2 50 6 Q53 10 56 6 Q53 2 50 6 Q47 10 44 6Z" fill={c} />;
  return (
    <svg viewBox="0 0 100 12" style={{ width: `${size * 9}mm`, height: `${size * 1.1}mm`, display: "block", margin: `${size * 0.15}mm auto ${size * 0.5}mm` }}>
      <line x1="10" y1="6" x2="42" y2="6" stroke={c} strokeWidth="0.8" /><line x1="58" y1="6" x2="90" y2="6" stroke={c} strokeWidth="0.8" />{mid}
    </svg>
  );
}
